export function latin1(u8, start = 0, end = u8.length) {
  let s = "";
  const CHUNK = 8192;
  for (let i = start; i < end; i += CHUNK) {
    s += String.fromCharCode.apply(null, u8.subarray(i, Math.min(i + CHUNK, end)));
  }
  return s;
}

export function utf8Decode(u8) {
  return new TextDecoder("utf-8").decode(u8);
}

export function utf8Encode(str) {
  return new TextEncoder().encode(str);
}

export function startsWith(u8, sig) {
  if (u8.length < sig.length) return false;
  for (let i = 0; i < sig.length; i++) if (u8[i] !== sig[i]) return false;
  return true;
}

const lowerByte = (b) => (b >= 65 && b <= 90 ? b + 32 : b);

// Case-insensitive ASCII byte search.
export function indexOfBytes(hay, needleStr, from = 0) {
  const n = needleStr.length;
  const needle = new Uint8Array(n);
  for (let i = 0; i < n; i++) needle[i] = lowerByte(needleStr.charCodeAt(i));
  const limit = hay.length - n;
  for (let i = from; i <= limit; i++) {
    let j = 0;
    while (j < n && lowerByte(hay[i + j]) === needle[j]) j++;
    if (j === n) return i;
  }
  return -1;
}

export function containsAny(u8, needles) {
  const found = [];
  for (const n of needles) if (indexOfBytes(u8, n) !== -1) found.push(n);
  return found;
}

export function concatBytes(parts) {
  const total = parts.reduce((s, p) => s + p.length, 0);
  const out = new Uint8Array(total);
  let o = 0;
  for (const p of parts) { out.set(p, o); o += p.length; }
  return out;
}

export function humanSize(n, lang = "en") {
  const [b, k, m] = lang === "fr" ? ["o", "Ko", "Mo"] : ["B", "KB", "MB"];
  const num = (v, d) => (lang === "fr" ? v.toFixed(d).replace(".", ",") : v.toFixed(d));
  if (n < 1024) return `${n} ${b}`;
  if (n < 1024 * 1024) return `${num(n / 1024, 1)} ${k}`;
  return `${num(n / 1024 / 1024, 2)} ${m}`;
}
